import request from "helper/request";
import combineLink from "helper/combineLink";
import api from "helper/api";


class SearchService {
    searchFetch = async (query) => {

        let options = {
            setLoading: false,
            withLoader: false,
            query: {query}
        }

        return request.get(combineLink(api.searchPartner), options)
    };
}

export const searchService = new SearchService();
